/* Kasho Pro wishlist — no app, no account; saved only in the visitor's own browser. */
(function () {
var KEY = 'kp_wishlist_v1';
var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3 4.6 13a4.7 4.7 0 0 1 0-6.7 4.7 4.7 0 0 1 6.7 0l.7.7.7-.7a4.7 4.7 0 0 1 6.7 0 4.7 4.7 0 0 1 0 6.7Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
function read() {
try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
catch (e) { return []; }
}
function write(list) {
try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
}
function saved(handle) { return read().indexOf(handle) > -1; }
function toggle(handle) {
var list = read(), i = list.indexOf(handle);
if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
write(list);
return i === -1;
}
function handleFrom(href) {
var m = String(href || '').match(/\/products\/([^/?#]+)/);
return m ? m[1] : null;
}
function styles() {
if (document.getElementById('kp-wish-style')) return;
var s = document.createElement('style');
s.id = 'kp-wish-style';
s.textContent = [
'.kp-wish{position:absolute;top:10px;right:10px;z-index:2;width:36px;height:36px;display:grid;place-items:center;border:0;border-radius:50%;',
'background:rgba(255,255,255,.92);color:#111;cursor:pointer;padding:0;transition:transform .15s ease,background .15s ease}',
'.kp-wish:hover{transform:scale(1.06)}',
'.kp-wish[aria-pressed="true"]{color:#b5532f}',
'.kp-wish[aria-pressed="true"] svg path{fill:currentColor}',
'.kp-wish:focus-visible{outline:2px solid #b5532f;outline-offset:2px}',
'.kp-card__media{position:relative}',
'.kp-wish-pdp{display:inline-flex;align-items:center;gap:8px;margin-top:12px;background:none;border:1px solid currentColor;',
'border-radius:50px;padding:10px 18px;font:inherit;font-size:.875rem;cursor:pointer;color:inherit}',
'.kp-wish-pdp[aria-pressed="true"]{color:#b5532f}',
'.kp-wish-pdp[aria-pressed="true"] svg path{fill:currentColor}',
'.kp-wish-link{position:relative;display:inline-grid;place-items:center;width:40px;height:40px;color:inherit}',
'.kp-wish-link b{position:absolute;top:2px;right:2px;min-width:16px;height:16px;border-radius:9px;background:#b5532f;color:#fff;',
'font-size:10px;line-height:16px;text-align:center;font-weight:600;padding:0 4px}',
'@media (prefers-reduced-motion: reduce){.kp-wish{transition:none}}'
].join('');
document.head.appendChild(s);
}
function button(handle, cls, label) {
var b = document.createElement('button');
b.type = 'button';
b.className = cls;
b.setAttribute('data-kp-wish', handle);
b.setAttribute('aria-pressed', saved(handle) ? 'true' : 'false');
b.setAttribute('aria-label', (saved(handle) ? 'Remove ' : 'Save ') + label + ' to your wishlist');
b.innerHTML = HEART + (cls === 'kp-wish-pdp' ? '<span>' + (saved(handle) ? 'Saved' : 'Save for later') + '</span>' : '');
return b;
}
function decorateCards(root) {
(root || document).querySelectorAll('.kp-card__media').forEach(function (media) {
if (media.querySelector('.kp-wish')) return;
var handle = handleFrom(media.getAttribute('href'));
if (!handle) return;
var card = media.closest('.kp-card');
var title = card ? (card.querySelector('.kp-card__title') || {}).textContent : '';
media.parentNode.insertBefore(button(handle, 'kp-wish', (title || 'this product').trim()), media.nextSibling);
media.parentNode.style.position = 'relative';
});
}
function decoratePdp() {
var form = document.querySelector('form[action*="/cart/add"]');
if (!form || document.querySelector('.kp-wish-pdp')) return;
var handle = handleFrom(window.location.pathname);
if (!handle) return;
var h1 = document.querySelector('h1');
form.parentNode.insertBefore(button(handle, 'kp-wish-pdp', h1 ? h1.textContent.trim() : 'this product'), form.nextSibling);
}
function decorateHeader() {
if (document.querySelector('.kp-wish-link')) return;
var cart = document.querySelector('#header-component a[href*="/cart"], header a[href*="/cart"]');
if (!cart) return;
var a = document.createElement('a');
a.className = 'kp-wish-link';
a.href = '/pages/wishlist';
a.setAttribute('aria-label', 'Wishlist');
a.innerHTML = HEART + '<b hidden>0</b>';
cart.parentNode.insertBefore(a, cart);
}
function sync() {
var list = read();
document.querySelectorAll('[data-kp-wish]').forEach(function (b) {
var on = list.indexOf(b.getAttribute('data-kp-wish')) > -1;
b.setAttribute('aria-pressed', on ? 'true' : 'false');
var span = b.querySelector('span');
if (span) span.textContent = on ? 'Saved' : 'Save for later';
});
var badge = document.querySelector('.kp-wish-link b');
if (badge) { badge.textContent = list.length; badge.hidden = list.length === 0; }
}
document.addEventListener('click', function (e) {
var b = e.target.closest ? e.target.closest('[data-kp-wish]') : null;
if (!b) return;
e.preventDefault();
toggle(b.getAttribute('data-kp-wish'));
sync();
if (document.querySelector('[data-kp-wishlist-root]')) render();
});
function money(cents, currency) {
try {
return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
} catch (e) { return '$' + (cents / 100).toFixed(2); }
}
function render() {
var root = document.querySelector('[data-kp-wishlist-root]');
if (!root) return;
var empty = document.querySelector('[data-kp-wishlist-empty]');
var currency = root.getAttribute('data-currency') || 'USD';
var list = read();
if (!list.length) {
root.innerHTML = '';
if (empty) empty.hidden = false;
return;
}
if (empty) empty.hidden = true;
root.setAttribute('aria-busy', 'true');
Promise.all(list.map(function (h) {
return fetch('/products/' + encodeURIComponent(h) + '.js')
.then(function (r) { return r.ok ? r.json() : null; })
.catch(function () { return null; });
})).then(function (items) {
root.setAttribute('aria-busy', 'false');
var html = items.filter(Boolean).map(function (p) {
var img = p.featured_image || (p.images && p.images[0]);
var price = money(p.price, currency);
var was = p.compare_at_price > p.price ? '<span class="kp-price__was">' + money(p.compare_at_price, currency) + '</span>' : '';
var cta = p.available
? '<a class="kp-btn kp-btn--accent kp-card__btn" href="/products/' + p.handle + '">View product</a>'
: '<span class="kp-btn kp-btn--muted kp-card__btn" aria-disabled="true">Sold out</span>';
return '<article class="kp-card">' +
'<a class="kp-card__media" href="/products/' + p.handle + '" tabindex="-1" aria-hidden="true">' +
(img ? '<img class="kp-card__img1" src="' + img + '&width=600" alt="" loading="lazy">' : '') + '</a>' +
'<button type="button" class="kp-wish" data-kp-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove ' + p.title.replace(/"/g, '&quot;') + ' from your wishlist">' + HEART + '</button>' +
'<div class="kp-card__body"><h3 class="kp-card__title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
'<div class="kp-card__foot"><div class="kp-price">' + was + '<span class="kp-price__now">' + price + '</span></div>' + cta + '</div></div></article>';
}).join('');
root.innerHTML = html;
});
}
function init() {
styles();
decorateCards();
decoratePdp();
decorateHeader();
render();
sync();
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
document.addEventListener('shopify:section:load', init);
window.addEventListener('pageshow', sync);
})();